import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { CTAButton, PageHero, SectionLabel } from '../components/shared';
import { LeadForm } from '../components/LeadForm';
import { services } from '../data/site';
export function ServiceDetail() {
  const {
    slug
  } = useParams();
  const service = services.find(s => s.slug === slug);
  if (!service) return <Navigate to="/services" replace data-id="element-462" />;
  const Icon = service.icon;
  return <>
      <PageHero eyebrow="Solution" title={service.title} subtitle={service.short} data-id="element-463">
        <div className="flex flex-wrap gap-3" data-id="element-464">
          <CTAButton to="/assessment" data-id="element-465">Get a custom plan</CTAButton>
          <CTAButton variant="secondary" to="/services" data-id="element-466">
            See all solutions
          </CTAButton>
        </div>
      </PageHero>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-id="element-467">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_.9fr]" data-id="element-468">
          <div data-id="element-469">
            <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-sky-100 text-sky-600" data-id="element-470">
              <Icon className="h-7 w-7" data-id="element-471" />
            </div>
            <p className="text-lg leading-8 text-slate-700" data-id="element-472">{service.long}</p>

            <h3 className="mt-12 text-2xl font-black" data-id="element-473">What is included</h3>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-474">
              {service.features.map(f => <div key={f} className="flex items-start gap-3 rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200" data-id="element-475">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 flex-none text-sky-500" data-id="element-476" />
                  <span className="text-sm font-bold text-slate-700" data-id="element-477">{f}</span>
                </div>)}
            </div>

            <h3 className="mt-12 text-2xl font-black" data-id="element-478">Common use cases</h3>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-479">
              {service.useCases.map(u => <div key={u} className="rounded-2xl border border-slate-200 bg-white p-5" data-id="element-480">
                  <p className="font-bold text-slate-800" data-id="element-481">{u}</p>
                </div>)}
            </div>

            <div className="mt-12 rounded-[2rem] bg-slate-950 p-8 text-white" data-id="element-482">
              <h3 className="text-2xl font-black" data-id="element-483">
                Want this for your property?
              </h3>
              <p className="mt-3 leading-7 text-slate-300" data-id="element-484">
                We will walk your property, identify the right placements, and
                send a clear plan and quote.
              </p>
              <div className="mt-6 flex flex-wrap gap-3" data-id="element-485">
                <CTAButton to="/assessment" data-id="element-486">Free assessment</CTAButton>
                <CTAButton variant="secondary" href="tel:+19168424729" data-id="element-487">
                  Call (916) 842-4729
                </CTAButton>
              </div>
            </div>
          </div>

          <aside className="lg:sticky lg:top-28 lg:self-start" data-id="element-488">
            <LeadForm defaultInterest={service.title} title={`Questions about ${service.title}?`} subtitle="Send us a quick note — we typically respond within one business day." data-id="element-489" />
            <div className="mt-6 rounded-[2rem] border border-slate-200 bg-white p-6" data-id="element-490">
              <p className="text-sm font-black uppercase tracking-wider text-slate-500" data-id="element-491">
                Other solutions
              </p>
              <div className="mt-4 grid gap-2" data-id="element-492">
                {services.filter(s => s.slug !== service.slug).map(s => <Link key={s.slug} to={s.slug === 'smart-home' ? '/smart-home' : `/services/${s.slug}`} className="flex items-center justify-between rounded-2xl bg-slate-50 px-4 py-3 text-sm font-bold text-slate-700 hover:bg-slate-100" data-id="element-493">
                      {s.title} <ArrowRight className="h-4 w-4 text-sky-500" data-id="element-494" />
                    </Link>)}
              </div>
            </div>
          </aside>
        </div>
      </section>
    </>;
}